import { render } from "./Nosotros.vue?vue&type=template&id=6f6cacc1&scoped=true"
import script from "./Nosotros.vue?vue&type=script&lang=js"
export * from "./Nosotros.vue?vue&type=script&lang=js"

import "./Nosotros.vue?vue&type=style&index=0&id=6f6cacc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6cacc1"]])

export default __exports__